import { useSiteContent } from '@/context/SiteContent';
import { Wordmark } from '@/components/yunti/Wordmark';

export function Nav() {
  const { brand, nav } = useSiteContent();
  return (
    <nav
      className="sticky top-0 z-50 bg-yunti-ground/90 backdrop-blur-md border-b border-yunti-ink/10 px-6 lg:px-12 py-4 flex items-center justify-between"
      aria-label="Main Navigation"
      data-testid="main-nav"
    >
      <div className="flex items-center gap-3">
        <svg
          className="w-7 h-7 text-yunti-ink"
          viewBox="0 0 32 32"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="square"
          aria-hidden="true"
        >
          <path d="M6 6v12a10 10 0 0020 0V6" />
          <path d="M16 6v14" stroke="rgb(var(--y-purple))" strokeWidth="2" />
        </svg>
        <a href="#hero" className="text-xl font-bold tracking-tighter uppercase font-display" data-testid="nav-brand-link">
          <Wordmark text={brand.name} />
        </a>
      </div>
      <div className="flex items-center gap-8 text-xs font-mono uppercase tracking-[0.18em]">
        <a href="#brand" className="link-hover hidden sm:inline-block" data-testid="nav-brand-section-link">
          {nav.brand}
        </a>
        <a href="#perspective" className="link-hover hidden sm:inline-block" data-testid="nav-drop-link">
          {nav.drop}
        </a>
        <a href="#products" className="link-hover" data-testid="nav-collection-link">
          {nav.collection}
        </a>
        <a
          href="#contact"
          className="px-4 py-2 bg-yunti-ink text-yunti-ground hover:bg-yunti-purple transition-colors rounded-none"
          data-testid="nav-contact-link"
        >
          {nav.contact}
        </a>
      </div>
    </nav>
  );
}
